import { render } from "./OrientationEvaluation.vue?vue&type=template&id=04b77da4"
import script from "./OrientationEvaluation.vue?vue&type=script&lang=js"
export * from "./OrientationEvaluation.vue?vue&type=script&lang=js"

import "./OrientationEvaluation.vue?vue&type=style&index=0&id=04b77da4&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__